import axiosInstance from "./axiosInstance";

export function create(param) {
  return axiosInstance.post('article/addArticle',param)
}

export function update(param) {
  return axiosInstance.post('article/editArticle',param)
}

export function del(param) {
	return axiosInstance.post('article/deleteArticle', param)
}

export function query(param) {
  return axiosInstance.post('article/queryArticleList',param)
}

export function queryNext(param) {
  return axiosInstance.post('article/queryNext',param)
}

export function upload(formData) {
	return axiosInstance.post('file/obsUploadFile', formData)
}

export function queryArticle(param) {
  return axiosInstance.post('article/queryArticleList',param)
}